import CrudManager from "@/components/admin/CrudManager";
import { formatDate } from "@/lib/format";
import { useSeo } from "@/hooks/useSeo";

const AdminBerita = () => {
  useSeo("Kelola Berita");
  return (
    <CrudManager
      title="Berita"
      description="Tambah, edit, dan hapus berita madrasah."
      endpoint="/news"
      prefix="admin-news"
      defaults={{ category: "Pengumuman", author: "Admin" }}
      columns={[
        { name: "image_url", image: true },
        { name: "title" },
        { name: "meta", render: (i) => `${i.category} • ${formatDate(i.date)} • ${i.author}` },
      ]}
      fields={[
        { name: "title", label: "Judul", type: "text", required: true, full: true, placeholder: "Judul berita" },
        { name: "category", label: "Kategori", type: "select", options: ["Akademik", "Prestasi", "Pengumuman", "Ekstrakurikuler"] },
        { name: "author", label: "Penulis", type: "text", placeholder: "Nama penulis" },
        { name: "date", label: "Tanggal", type: "date" },
        { name: "image_url", label: "Gambar Berita", type: "image" },
        { name: "excerpt", label: "Ringkasan", type: "textarea", rows: 2, placeholder: "Ringkasan singkat" },
        { name: "content", label: "Isi Berita", type: "textarea", rows: 8, placeholder: "Tulis isi berita (pisahkan paragraf dengan enter)" },
      ]}
    />
  );
};

export default AdminBerita;
